import React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import Lisa from "../../../assets/shortlist_22/lisa.JPG";
import Hauwa from "../../../assets/shortlist_22/hauwa.jpg";
import Johnstone from "../../../assets/shortlist_22/johnstone.jpg";
import Taiwo from "../../../assets/shortlist_22/taiwo.jpg";

const solutionNominees = [
  {
    name: "Gwamkat Lisa Gwamzhi",
    title: "Radio Nigeria",
    imgpath: Lisa,
    story:
      "Gwamkat Lisa Gwamzhi is Broadcast Journalist at Federal Radio Corporation of Nigeria and passionate about social justice and an advocate for  the just.",
  },
  {
    name: "Hauwa Shaffii Nuhu",
    title: "Humangle Media",
    imgpath: Hauwa,
    story:
      "Hauwa Shaffii Nuhu is a journalist from Nigeria who works with HumAngle Media where she covers migration and displacement across the northern region of the country, especially the northeast.",
  },
  {
    name: "Johnstone Kpilaakaa",
    title: "Freelance Journalist",
    imgpath: Johnstone,
    story:
      "Johnstone Kpilaakaa is a Nigerian Journalist. He currently covers tech in Africa at Benjamindada.com, a tech media outlet based in Lagos. He also reports on newsroom innovations across Africa for the International Centre for Journalists, Washington DC.",
  },
  {
    name: "Taiwo Adebulu",
    title: "TheCable",
    imgpath: Taiwo,
    story:
      "Taiwo Adebulu is the pioneer head of fact-check desk at TheCable. He has seven years of experience covering development and investigative stories. ",
  },
];

const SolutionNominees = () => {
  return (
    <Grid
      item
      xs={12}
      md={12}
      marginTop={{ xs: "10%", sm: "3%" }}
      data-aos={"fade-up"}
    >
      <Typography
        variant={"h5"}
        fontWeight={400}
        paddingBottom={"2%"}
        color={"#049593"}
      >
        Solutions Journalism Award (Shortlisted Nominees)
      </Typography>
      <Grid item xs={12} md={12} display={"flex"} flexWrap={"wrap"}>
        {solutionNominees.map((nominate, index) => {
          const { name, title, imgpath, story } = nominate;
          return (
            <Grid
              key={index}
              item
              xs={12}
              md={3}
              marginBottom={{ xs: "7%", sm: "2%" }}
            >
              <Card
                sx={{
                  maxWidth: 260,
                  height: "100%",
                  borderTop: "10px solid #D7A036",
                }}
              >
                <CardActionArea>
                  <CardContent>
                    <Avatar
                      alt={name}
                      src={imgpath}
                      sx={{ width: 126, height: 126 }}
                    />
                    <Typography
                      gutterBottom
                      variant="h6"
                      color={"#004165"}
                      component="div"
                      textAlign={"center"}
                    >
                      {name}
                    </Typography>
                    <Typography
                      variant="body2"
                      fontWeight={700}
                      color="#049593"
                      paragraph
                      textAlign={"center"}
                    >
                      {title}
                    </Typography>
                    <Typography
                      paragraph
                      variant="body2"
                      fontWeight={400}
                      color="#4f4f4f"
                      textAlign={"center"}
                    >
                      {story}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default SolutionNominees;
